import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BsLinkedin } from "react-icons/bs";
import axios from "axios";

export function ContactPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");

  return (
    <div className="flex justify-center items-center flex-column mt-4">
      <form
        className="flex flex-column"
        style={{ width: "400px", maxWidth: "90%" }}
      >
        <label>Name</label>
        <input
          className="w-100"
          type={"text"}
          required={true}
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
        <label>Email</label>
        <input
          className="w-100"
          type={"email"}
          required={true}
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <label>Message</label>
        <textarea
          rows={8}
          required={true}
          className="w-100"
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
        />
        <div className="flex flex-end justify-center">
          <Link to="/main" className="button alt">
            Go back
          </Link>
          <a
            href={"https://www.linkedin.com/company/mace-legal/"}
            target={"_blank"}
          >
            <BsLinkedin size={32} className="mr-4 ml-4 blue" />
          </a>
          <input
            type="submit"
            className="button"
            onClick={async () => {
              await axios.post(`${process.env.REACT_APP_BACKEND_URL}/contact`, {
                name: name,
                email: email,
                message: message,
              });
              setStatus("Message sent!");
            }}
          />
        </div>
        <div>{status}</div>
      </form>
    </div>
  );
}
